import React, { useEffect, useState, useContext } from "react";
import useMediaQuery from '@mui/material/useMediaQuery';

export const BeachClub = (props) => {
    const [sectionMarginTop, setSectionMarginTop] = useState('');
    const notMobile = useMediaQuery('(min-width:992px)');

    useEffect(() => {
        if (notMobile) {
        let rowPaddingBeach = document.querySelector('.box-beachclub').getBoundingClientRect().height;
        setSectionMarginTop(rowPaddingBeach + "px");
        }
    }, [notMobile]);


    return (
        <>
            {props.cultureCode === "en-us" &&
                <div className="container-fluid bkg-beachclub">
                    <div className="container py-5">
                        <div className="row justify-content-center">
                            <div className="col-md-10 text-center pt-5" data-aos="zoom-in">
                                <h2 className="text-uppercase mb-3 text-white">A fabulous journey starts here</h2>
                                <img src="images/Infynito80/beach-club/main.jpg" alt="" className="w-100" />
                            </div>
                            <div className="col-lg-6 position-relative order-2 order-lg-1" data-aos="fade-up" data-aos-duration="1500">
                                <img src="images/Infynito80/pin.svg" alt="" className="pin pin-cockpit pin-animation" />
                                <img src="images/Infynito80/pin.svg" alt="" className="pin pin-stern pin-animation" />
                                <img src="images/Infynito80/main-deck.png" alt="" className="main-deck-beachclub w-100" />
                            </div>
                            <div className="col-lg-6 position-relative order-1 order-lg-2">
                                <div className="box box-beachclub">
                                    <h3 className="mb-3">Beach area</h3>
                                    <p><strong>Cockpit</strong>: the cockpit lounge with free standing furniture provides greater flexibility in terms of configuration and utilization, offering ample space for relaxation and social gatherings.</p>
                                    <p><strong>Stern</strong>: a generously peaceful sea-view beach area that features a sea-view couch incorporating a spacious storage unit. Additionally, there is a stern platform with a linear lift for launching and hauling up a toy up to 4 meters.</p>
                                </div>
                            </div>
                        </div>
                        <div className="row pb-lg-5" style={{ marginTop: sectionMarginTop }}></div>
                    </div>
                </div>
            }
            {props.cultureCode === "it-it" && 
                <div className="container-fluid bkg-beachclub">
                    <div className="container py-5">
                        <div className="row justify-content-center">
                            <div className="col-md-10 text-center pt-5" data-aos="zoom-in">
                                <h2 className="text-uppercase mb-3 text-white">Un meraviglioso viaggio ha inizio</h2>
                                <img src="images/Infynito80/beach-club/main.jpg" alt="" className="w-100" />
                            </div>
                            <div className="col-lg-6 position-relative order-2 order-lg-1" data-aos="fade-up" data-aos-duration="1500">
                                <img src="images/Infynito80/pin.svg" alt="" className="pin pin-cockpit pin-animation" />
                                <img src="images/Infynito80/pin.svg" alt="" className="pin pin-stern pin-animation" />
                                <img src="images/Infynito80/main-deck.png" alt="" className="main-deck-beachclub w-100" />
                            </div>
                            <div className="col-lg-6 position-relative order-1 order-lg-2">
                                <div className="box box-beachclub">
                                    <h3 className="mb-3">Beach area</h3>
                                    <p><strong>Pozzetto</strong>: il pozzetto con arredi completamente free standing offre flessibilità nella configurazione e nell'utilizzo, con ampio spazio per il relax e per momenti conviviali a bordo.</p>
                                    <p><strong>Specchio di poppa</strong>: la poppa, con la sua ampia beach area fronte mare, è dotata di un comodo divano con spazio di stivaggio integrato e una plancetta con linear lift, per varare un tender fino a 4 metri di lunghezza o un jetski.</p>
                                </div>
                            </div>
                        </div>
                        <div className="row pb-lg-5" style={{ marginTop: sectionMarginTop }}></div>
                    </div>
                </div>
            }



        </>
    );




};

export default BeachClub;